import React, {PureComponent, ReactNode, StrictMode} from "react"
import {Step} from "@App/Components/Stepper/Step";

type StepperProps = {
    currentStep: number
    onChange: (id: number) => void
    children: ReactNode[]
}

export class Stepper extends PureComponent<StepperProps> {

    public increment = (step?: number) => {
        this.props.onChange(step ? step : this.props.currentStep - 1)
    }

    public decrement = (step?: number) => {
        this.props.onChange(step ? step : this.props.currentStep - 1)
    }

    public static Step = Step

    render(): ReactNode {

        const {children, currentStep} = this.props

        return (
            <StrictMode>
                {children &&
                    React.Children.map(children.filter(x => !!x), (child, idx) => {
                        if (React.isValidElement(child)) {
                            return React.cloneElement(child as React.ReactElement<any>, {
                                id: idx,
                                open: idx === currentStep,
                                completed: idx < currentStep,
                                last: idx === children.length - 1,
                                onBackToStep: () => this.decrement(idx)
                            });
                        }
                    })
                }
            </StrictMode>
        );
    }
}
